const e = {
  postV1OwnertypeOwneridLaunch: {
    schema: {
      method: "post",
      url: "/v1/{ownerType}/{ownerId}/launch",
      mediaType: "application/json"
    }
  },
  getV1ProviderConfigs: {
    schema: {
      method: "get",
      url: "/v1/provider-configs"
    }
  },
  headV1ProviderConfigs: {
    schema: {
      method: "head",
      url: "/v1/provider-configs"
    }
  },
  postV1ProviderConfigs: {
    schema: {
      method: "post",
      url: "/v1/provider-configs",
      mediaType: "application/vnd.api+json"
    }
  },
  getV1ProviderConfigsId: {
    schema: {
      method: "get",
      url: "/v1/provider-configs/{id}"
    }
  },
  headV1ProviderConfigsId: {
    schema: {
      method: "head",
      url: "/v1/provider-configs/{id}"
    }
  },
  patchV1ProviderConfigsId: {
    schema: {
      method: "patch",
      url: "/v1/provider-configs/{id}",
      mediaType: "application/vnd.api+json"
    }
  },
  deleteV1ProviderConfigsId: {
    schema: {
      method: "delete",
      url: "/v1/provider-configs/{id}"
    }
  },
  getV1ProviderConfigsIdRelationshipname: {
    schema: {
      method: "get",
      url: "/v1/provider-configs/{id}/{relationshipName}"
    }
  },
  headV1ProviderConfigsIdRelationshipname: {
    schema: {
      method: "head",
      url: "/v1/provider-configs/{id}/{relationshipName}"
    }
  },
  getV1ProviderConfigsIdRelationshipsRelationshipname: {
    schema: {
      method: "get",
      url: "/v1/provider-configs/{id}/relationships/{relationshipName}"
    }
  },
  headV1ProviderConfigsIdRelationshipsRelationshipname: {
    schema: {
      method: "head",
      url: "/v1/provider-configs/{id}/relationships/{relationshipName}"
    }
  },
  postV1ProviderConfigsIdRelationshipsRelationshipname: {
    schema: {
      method: "post",
      url: "/v1/provider-configs/{id}/relationships/{relationshipName}",
      mediaType: "application/json"
    }
  },
  patchV1ProviderConfigsIdRelationshipsRelationshipname: {
    schema: {
      method: "patch",
      url: "/v1/provider-configs/{id}/relationships/{relationshipName}",
      mediaType: "application/json"
    }
  },
  deleteV1ProviderConfigsIdRelationshipsRelationshipname: {
    schema: {
      method: "delete",
      url: "/v1/provider-configs/{id}/relationships/{relationshipName}",
      mediaType: "application/json"
    }
  }
};
export {
  e as v1Service
};
